import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { List as AccountsIcon, Twitter, ArrowUpRight } from 'react-feather'
import Link, { BasicLink } from '../Link'
import getEnvironmentVar from '../../utils/getEnvironmentVar'
import { ENERGISWAP_LINKS, MENU_LINKS } from '../../constants'
import { ReactComponent as Discord } from '../../assets/images/Discord.svg'

const version = getEnvironmentVar('VERSION')
const Container = styled.div`
  position: fixed;
  top: 120px;
  left: 0px;
  z-index: 9999;
  height: calc(100% - 184px);
  width: 100%;
  background: linear-gradient(180deg, rgba(41,41,43,1) 0%, rgba(29,29,31,1) 25%, rgba(8,9,9,1) 100%);
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 16px;
  justify-content: start;
  gap: 16px;
  box-sizing: border-box;
  overflow-y: auto;

  @media (max-width: 550px) {
    padding: 30px;
  }

  -webkit-scrollbar-track {
    width: 40px;
  }
`

const MenuOptionDiv = styled(BasicLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 56px;
  background-color: rgba(44, 47, 54, 1);
  border-radius: 6px;
  padding: 16px;
  box-sizing: border-box;
  opacity: 0.7;
  
  :hover {
    cursor: pointer;
    opacity: 1;
  }
`

const MenuSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 14px;
  width: 100%
`

const FooterMenuOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
  color: white;
  opacity: 0.9;
  font-size: 16px;

  :hover {
    opacity: 1;
    cursor: pointer;
  }
`

const VersionSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  opacity: 0.7;
  color: ${({ theme }) => theme.white};
`

const HeadingDiv = styled.div`
  color: rgba(137, 138, 140, 1);
  font-size: 14px;
  font-weight: 500;

  :hover {
    cursor: default;
  }
`

const TwitterIcon = styled(Twitter)`
  fill: ${({ theme }) => theme.white};
  opacity: 0.7;
  width: 18px !important;
`

const DiscordIcon = styled(Discord)`
  width: 22px;
  padding-bottom: 2px;
`

const LinkNameIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
  margin: 16px 0px;
`

const MenuOptionLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(44, 47, 54, 1);
  border-radius: 6px;
  width: 100%;
  min-height: 56px;
  padding: 0px 16px;
  font-size: 14px;
  text-decoration: none;
  color: white !important;
  font-size: 14px;
  opacity: 0.7;

  :hover {
    cursor: pointer;
    opacity: 1;
  }
`

const EnergiswapLinks = ({ type, close }) => {
  return <MenuSection>
    {Object.keys(ENERGISWAP_LINKS).map((key) => {
      return ENERGISWAP_LINKS[key].type === type ? (
        <MenuOptionLink key={key} href={ENERGISWAP_LINKS[key].link} target="_blank" rel="noopener noreferrer" onClick={() => close(false)}>
          {ENERGISWAP_LINKS[key].name}<ArrowUpRight size={14} />
        </MenuOptionLink>
      ) : ''
    })}
  </MenuSection>
}


export default function MobileMenu({ setMenuOpen }) {
  const history = useHistory()

  return (
    <Container>
      <HeadingDiv>MORE ANALYTICS</HeadingDiv>
      <MenuSection>
        <MenuOptionDiv to={MENU_LINKS['ACCOUNTS'].to} onClick={() => setMenuOpen(false)} >
          <FooterMenuOption activeText={MENU_LINKS['ACCOUNTS'].activeKeys.includes(history.location.pathname.split('/')[1])}>
            <AccountsIcon />
            {MENU_LINKS['ACCOUNTS'].text.split(' ')[0]}
          </FooterMenuOption>
        </MenuOptionDiv>
      </MenuSection>

      <HeadingDiv>ENERGISWAP</HeadingDiv>
      <EnergiswapLinks type={'energiswap'} close={setMenuOpen} />

      <HeadingDiv>HELP</HeadingDiv>
      <EnergiswapLinks type={'help'} close={setMenuOpen} />


      <HeadingDiv>JOIN COMMUNITY</HeadingDiv>
      <MenuSection>
        <MenuOptionLink href={ENERGISWAP_LINKS['DISCORD'].link} target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>
          <LinkNameIcon><DiscordIcon />{ENERGISWAP_LINKS['DISCORD'].name}</LinkNameIcon>
          <ArrowUpRight size={14} />
        </MenuOptionLink>
        <MenuOptionLink href={ENERGISWAP_LINKS['TWITTER'].link} target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>
          <LinkNameIcon><TwitterIcon />{ENERGISWAP_LINKS['TWITTER'].name}</LinkNameIcon>
          <ArrowUpRight size={14} />
        </MenuOptionLink>
      </MenuSection>

      <VersionSection>
        Version {version}
      </VersionSection>
    </Container>
  )
}
